(() => {
  class CompleteTheLook extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.$drawer = document.querySelector(`[data-dynamic-drawer="right"]`);
      this.$header = this.querySelector(
        "[data-complete-the-look-header]"
      ).cloneNode(true);
      this.$content = document.querySelector(
        `[data-complete-the-look-content="${this.getAttribute("product-id")}"]`
      );

      this.addEventListener("click", () => {
        this.$drawer.fillAndShow({
          title: this.$header.outerHTML,
          body: this.$content.innerHTML,
          type: "complete-the-look",
        });
      });
    }
  }

  customElements.define("complete-the-look", CompleteTheLook);
})();
